import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b58a389e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58a389e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b58a389e')) {
      api.createRecord('b58a389e', component.options)
    } else {
      api.reload('b58a389e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b58a389e&scoped=true&", function () {
      api.rerender('b58a389e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24LP8l758n1Kf/JS/comp/Accordion.vue"
export default component.exports